// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"d8d25148","347":"ff7a9f9f","493":"243f5fa3","912":"b527158e"}[chunkId] + ".chunk.css";
};